<template>
  <section class="root">
    <div class="grid-flow">
      <cms-loading v-if="busy"></cms-loading>
      <router-link class="garage accent-hover" :key="g.slug" v-for="g in list" :to="generateLink(g.slug)"
        data-inspect="link">
        <p>
          <span>{{ g.name }}</span>
          <img :src="$api.replaceLocalhost(g.image)" :alt="g.name" width="30" height="30" loading="lazy">
        </p>
      </router-link>
    </div>
  </section>
</template>

<script>
import cms, { loads } from "@/mixins/cms.js";
export default {
  mixins: [cms, loads],
  name: "cms-garage-list",
  methods: {
    generateLink(slug) {
      return `/${this.$language.current}/dealers/${slug?.toLowerCase()}`
    }
  },
  async fetch() {
    const { data: { results: garages } } = await this.$api.get(`public_api/dealers/?order_by=-vehicle_count`)
    this.list = garages;
    this.busy = false;
  },
}
</script>

<style scoped>
div.grid-flow {
  --flow-width: 200px;
}

a.garage {
  text-decoration: none;
  color: var(--crf-text);
  padding: 0.8rem;
  border-radius: 8px;
  background-color: var(--crf-bg-high);
  box-shadow: var(--crf-shadow);
}

a.garage img {
  border-radius: 50%;
  aspect-ratio: 1/1;
  object-fit: cover;
  width: 30px;
  height: 30px;
}

a.garage p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.95rem;
  margin: 0;
  padding: 0;
}

a.garage p span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
